import { render, staticRenderFns } from "./cardProductoPedido.vue?vue&type=template&id=19f285b6&scoped=true&"
import script from "./cardProductoPedido.vue?vue&type=script&lang=js&"
export * from "./cardProductoPedido.vue?vue&type=script&lang=js&"
import style0 from "./cardProductoPedido.vue?vue&type=style&index=0&id=19f285b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f285b6",
  null
  
)

export default component.exports